<div class="hw-box-content">
    <div class="hw-header-wrap">
        <div class="row">
            <div class="col-6">
                <i class="fn-global-site"></i>
                Daywise Alert
            </div>
        </div>
    </div>
    <div class="hw-title">
        <div class="row">
          <div class="col-12">
            <ul class="list-inline">
              <li class="align-top">
                <fn-date-range-picker [startDate]="dateRangeObject.startDate" [futureDateDisabled]="true"
                  [maxDate]="maxDateRange" (dateCB)="changeDate($event)" [endDate]="dateRangeObject.endDate">
                </fn-date-range-picker>
              </li>
              <li class="align-top pt-7">
              <div class="form-check">
                <label class="form-check-label" for="inlineFormCheck">
                  Select Product
                </label>
              </div>
            </li>
            <li class="align-top width-210px">
              <fn-select [labelKey]="'name'" [inputKey]="'primaryKey'" [optionList]="productArray" (changeEvent)="getIdenNoData()"
                [placeholder]="'Select Product'" [(ngModel)]="selectProduct" [ngModelOptions]="{standalone: true}">
              </fn-select>
            </li>
              <li class="align-top pt-7">
                <div class="form-check">
                  <label class="form-check-label" for="inlineFormCheck">
                    Select IdenNo
                  </label>
                </div>
              </li>
              <li class="align-top width-200px">
                <fn-select [labelKey]="'idenNo'" [inputKey]="'primaryKey'" [optionList]="idenNoArray"
                  [placeholder]="'Select idenNo'" [(ngModel)]="selectIdenNo" [ngModelOptions]="{standalone: true}">
                </fn-select>
              </li>
              <li class="align-top pt-7">
                <div class="form-check">
                  <label class="form-check-label" for="inlineFormCheck">
                    Description
                  </label>
                </div>
              </li>
      
              <li class="align-top pt-1">
                <fn-base-input name="description" [(ngModel)]="description" [dataKey]="'description'" [type]="'string'" [fnInputValidator]></fn-base-input>
              </li>

              <li class="align-top">
                <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'GO'"
                  (click)="getHistData(selectIdenNo)"></fn-button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    <div class="hw-content">
        <div class="row">
            <div class="col-12 text-center">
              @if (uiMap.isDataLoaded) {
              <fn-table [config]='config' [rowMetaArray]='rowMetaArray' [dataArray]='dayHistoryArray' [pageSize]="15"></fn-table>                            
              }
            </div>
        </div>
    </div>
</div>

